import React from 'react';
import './App.css';
import Hero from './HeroProposals';
import logo from './logo.svg';

function App() {
  return (
    <div className="App">
      {/* ── Navigation ── */}
      <header className="nav">
        <div className="container">
          <div className="logo-wrapper">
            <img src={logo} className="logo-mark" alt="Business Date" />
            <h1 className="logo">Business <span className="logo-accent">Date</span></h1>
          </div>
          <nav>
            <a href="#concept">Concept</a>
            <a href="#events">Eventi</a>
            <a href="#how-it-works">Come Funziona</a>
            <a href="#target">A chi è rivolto</a>
            <a href="#contact" className="nav-cta">Contattaci</a>
          </nav>
        </div>
      </header>

      <Hero />

      {/* ── Value Props ── */}
      <section className="section value-props">
        <div className="container">
          <div className="vp-grid">
            <div className="vp-card">
              <div className="vp-icon">🤝</div>
              <h3>Connessioni Vere</h3>
              <p>Niente badge, niente formalità. Solo persone interessanti e conversazioni autentiche.</p>
            </div>
            <div className="vp-card">
              <div className="vp-icon">🥂</div>
              <h3>Aperitivo Incluso</h3>
              <p>Un drink e un'atmosfera rilassata per rompere il ghiaccio in modo naturale.</p>
            </div>
            <div className="vp-card">
              <div className="vp-icon">⚡</div>
              <h3>Speed Networking</h3>
              <p>Turni rapidi per conoscere tutti i partecipanti, poi spazio libero per approfondire.</p>
            </div>
            <div className="vp-card">
              <div className="vp-icon">📋</div>
              <h3>Posti Limitati</h3>
              <p>Eventi esclusivi con un numero ristretto di partecipanti per garantire qualità.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ── Concept ── */}
      <section id="concept" className="section concept">
        <div className="container">
          <div className="concept-grid">
            <div className="concept-text">
              <span className="section-tag">Il Concept</span>
              <h2>Dove il <span className="text-accent">business</span> incontra il piacere di un <span className="text-accent">aperitivo</span></h2>
              <p>Business Date è il format che unisce il meglio del networking professionale e la convivialità di un aperitivo. Una via di mezzo tra le piattaforme di networking e gli eventi social, pensato per persone dinamiche e smart.</p>
              <p>Ogni evento è un'occasione per incontrare professionisti, imprenditori e talenti in un'atmosfera rilassata, davanti a un buon drink. Il doppio significato di <strong>"Date"</strong> — appuntamento romantico e incontro professionale — è il cuore del nostro concept.</p>
              <div className="concept-stats">
                <div className="stat">
                  <span className="stat-num">50+</span>
                  <span className="stat-label">Professionisti per evento</span>
                </div>
                <div className="stat">
                  <span className="stat-num">3</span>
                  <span className="stat-label">Città attive</span>
                </div>
                <div className="stat">
                  <span className="stat-num">100%</span>
                  <span className="stat-label">Networking garantito</span>
                </div>
              </div>
            </div>
            <div className="concept-visual">
              <div className="cv-card cv-card-img">
                <img src={`${process.env.PUBLIC_URL}/images/concept-image.png`} alt="Networking e aperitivo Business Date" className="cv-image" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── How it works ── */}
      <section id="how-it-works" className="section how-it-works">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Come Funziona</span>
            <h2>In quattro <span className="text-accent">semplici</span> passi</h2>
          </div>
          <div className="timeline">
            <div className="timeline-step">
              <div className="ts-num-wrap">
                <div className="ts-num">1</div>
                <div className="ts-line" />
              </div>
              <div className="ts-content">
                <h3>Scegli l'evento</h3>
                <p>Consulta il calendario e prenota il tuo posto. I posti sono limitati per garantire la qualità degli incontri.</p>
              </div>
            </div>
            <div className="timeline-step">
              <div className="ts-num-wrap">
                <div className="ts-num">2</div>
                <div className="ts-line" />
              </div>
              <div className="ts-content">
                <h3>Arriva e registrati</h3>
                <p>Check-in rapido all'ingresso. Ti aspettiamo con un drink di benvenuto.</p>
              </div>
            </div>
            <div className="timeline-step">
              <div className="ts-num-wrap">
                <div className="ts-num">3</div>
                <div className="ts-line" />
              </div>
              <div className="ts-content">
                <h3>Speed networking</h3>
                <p>5 minuti a turno per conoscere ogni partecipante. Abbastanza per capire se c'è feeling.</p>
              </div>
            </div>
            <div className="timeline-step">
              <div className="ts-num-wrap">
                <div className="ts-num">4</div>
              </div>
              <div className="ts-content">
                <h3>Aperitivo libero</h3>
                <p>Approfondisci i contatti in un'atmosfera rilassata. Il momento clou dell'evento.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Events ── */}
      <section id="events" className="section events">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Prossimi Eventi</span>
            <h2>Segna in <span className="text-accent">agenda</span></h2>
          </div>
          <div className="event-grid">
            <div className="event-card">
              <img src={`${process.env.PUBLIC_URL}/images/event-milano.png`} alt="Aperitivo di networking a Milano" className="ec-img" />
              <div className="ec-body">
                <div className="ec-date">Ott 10</div>
                <h3>Milano</h3>
                <p>Aperitivo di networking in zona Brera</p>
                <div className="ec-footer">
                  <span className="event-badge">Prossimamente</span>
                  <span className="ec-spots">12 posti rimasti</span>
                </div>
              </div>
            </div>
            <div className="event-card">
              <img src={`${process.env.PUBLIC_URL}/images/event-roma.png`} alt="Speed networking a Roma" className="ec-img" />
              <div className="ec-body">
                <div className="ec-date">Ott 24</div>
                <h3>Roma</h3>
                <p>Speed networking a Trastevere</p>
                <div className="ec-footer">
                  <span className="event-badge">Prossimamente</span>
                  <span className="ec-spots">8 posti rimasti</span>
                </div>
              </div>
            </div>
            <div className="event-card">
              <img src={`${process.env.PUBLIC_URL}/images/event-torino.png`} alt="Business aperitivo a Torino" className="ec-img" />
              <div className="ec-body">
                <div className="ec-date">Nov 7</div>
                <h3>Torino</h3>
                <p>Business aperitivo al centro</p>
                <div className="ec-footer">
                  <span className="event-badge">Prossimamente</span>
                  <span className="ec-spots">15 posti rimasti</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Gallery ── */}
      <section id="gallery" className="section gallery">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Gallery</span>
            <h2>L'atmosfera <span className="text-accent">Business Date</span></h2>
          </div>
          <div className="gallery-grid">
            {[1, 2, 3, 4, 5, 6].map((n) => (
              <div className="gallery-item" key={n}>
                <img src={`${process.env.PUBLIC_URL}/images/gallery-${n}.png`} alt={`Business Date gallery ${n}`} loading="lazy" />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Testimonials ── */}
      <section className="section testimonials">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Dicono di Noi</span>
            <h2>Cosa dice <span className="text-accent">chi c'è già stato</span></h2>
          </div>
          <div className="testimonial-grid">
            <div className="testimonial-card">
              <div className="testi-stars">★★★★★</div>
              <p>"Ho conosciuto tre potenziali clienti in una sera. Molto meglio di un evento corporate."</p>
              <div className="testi-author">
                <div className="testi-avatar">MR</div>
                <div>
                  <strong>Marco R.</strong>
                  <span>Consulente Marketing</span>
                </div>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="testi-stars">★★★★★</div>
              <p>"Atmosfera incredibile. Ho fatto networking senza sentire la pressione di doverlo fare."</p>
              <div className="testi-author">
                <div className="testi-avatar">SG</div>
                <div>
                  <strong>Serena G.</strong>
                  <span>Product Manager</span>
                </div>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="testi-stars">★★★★★</div>
              <p>"L'idea del doppio significato di Date è geniale. Funziona davvero per rompere il ghiaccio."</p>
              <div className="testi-author">
                <div className="testi-avatar">AL</div>
                <div>
                  <strong>Alessandro L.</strong>
                  <span>Startup Founder</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Target ── */}
      <section id="target" className="section target">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">A chi è rivolto</span>
            <h2>Chi <span className="text-accent">incontri</span> a Business Date</h2>
          </div>
          <div className="target-cards">
            <div className="target-card">
              <div className="target-icon-wrap" style={{ background: 'rgba(224, 122, 95, 0.12)' }}>
                <span className="target-icon">💼</span>
              </div>
              <h3>Professionisti</h3>
              <p>Dipendenti di aziende private che cercano svago e nuovi contatti professionali.</p>
            </div>
            <div className="target-card">
              <div className="target-icon-wrap" style={{ background: 'rgba(244, 162, 97, 0.12)' }}>
                <span className="target-icon">🎯</span>
              </div>
              <h3>Talenti</h3>
              <p>Ragazzi e ragazze in cerca di lavoro e opportunità, in un contesto informale.</p>
            </div>
            <div className="target-card">
              <div className="target-icon-wrap" style={{ background: 'rgba(224, 122, 95, 0.12)' }}>
                <span className="target-icon">🚀</span>
              </div>
              <h3>Manager</h3>
              <p>Imprenditori e manager che vogliono espandere la propria rete in modo autentico.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ── CTA Banner ── */}
      <section className="section cta-banner">
        <div className="container">
          <div className="cta-banner-inner">
            <h2>Pronto a <span className="text-accent">connetterti</span>?</h2>
            <p>Unisciti ai prossimi eventi e scopri il networking come non l'hai mai vissuto.</p>
            <a href="#contact" className="cta pulse-glow">Prenota il tuo posto →</a>
          </div>
        </div>
      </section>

      {/* ── Contact ── */}
      <section id="contact" className="section contact">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Contattaci</span>
            <h2>Vuoi partecipare o <span className="text-accent">organizzare</span> un evento?</h2>
          </div>
          <div className="contact-wrapper">
            <div className="contact-info">
              <div className="ci-item">
                <span className="ci-icon">📧</span>
                <div>
                  <strong>Email</strong>
                  <p>info@businessdate.it</p>
                </div>
              </div>
              <div className="ci-item">
                <span className="ci-icon">📱</span>
                <div>
                  <strong>Telefono</strong>
                  <p>+39 02 1234567</p>
                </div>
              </div>
              <div className="ci-item">
                <span className="ci-icon">📍</span>
                <div>
                  <strong>Location</strong>
                  <p>Milano · Roma · Torino</p>
                </div>
              </div>
            </div>
            <form className="contact-form">
              <div className="cf-row">
                <input type="text" placeholder="Nome" required />
                <input type="email" placeholder="Email" required />
              </div>
              <textarea placeholder="Messaggio" rows="4" required></textarea>
              <button type="submit" className="cta">Invia richiesta</button>
            </form>
          </div>
        </div>
      </section>

      {/* ── Footer ── */}
      <footer className="footer">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-brand">
              <div className="footer-logo">
                <img src={logo} className="footer-logo-mark" alt="" />
                <span>Business <strong>Date</strong></span>
              </div>
              <p>Networking &amp; Aperitivo. Incontri, in modo smart.</p>
            </div>
            <div className="footer-links">
              <h4>Link</h4>
              <a href="#concept">Concept</a>
              <a href="#events">Eventi</a>
              <a href="#how-it-works">Come Funziona</a>
            </div>
            <div className="footer-links">
              <h4>Legal</h4>
              <a href="#privacy">Privacy Policy</a>
              <a href="#cookie">Cookie Policy</a>
            </div>
            <div className="footer-social">
              <h4>Seguici</h4>
              <div className="social-icons">
                <a href="/" className="social-icon" aria-label="Instagram">IG</a>
                <a href="/" className="social-icon" aria-label="LinkedIn">IN</a>
                <a href="/" className="social-icon" aria-label="Facebook">FB</a>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <p>© 2026 Business Date. Tutti i diritti riservati.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;